module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "certificate"
  }, [_c('div', {
    staticStyle: {
      "min-height": "calc(100% - 220px)",
      "box-sizing": "border-box"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "commonW"
  }, [_c('div', {
    staticClass: "step03",
    staticStyle: {
      "max-width": "900px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("常见问题")]), _vm._v(" "), _c('div', {
    staticClass: "stepQues"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "如何查看找到项目编号及安全码信息？",
      "name": "1"
    }
  }, [_c('div', [_vm._v("项目编号及安全码，可以在线下平台激活卡获取，激活卡随着产品销售同步配套发货。")]), _vm._v(" "), _c('div', [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', [_c('div', [_vm._v("使用须知：")]), _vm._v(" "), _c('div', [_vm._v("1、软件下载安装：")]), _vm._v(" "), _c('div', [_vm._v("下载地址：http://gofile.me/2UNgV/GrTDZkTLA")]), _vm._v(" "), _c('div', [_vm._v("2、软件证书获取：")]), _vm._v(" "), _c('div', [_vm._v("证书网址：https://cert.jia-r.com/search")]), _vm._v(" "), _c('div', [_vm._v("3、软件激活：")]), _vm._v(" "), _c('div', [_vm._v("导入证书文件，软件激活成功")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("项目编号：12211221")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_vm._v("安全码：")]), _vm._v(" "), _c('span', {
    staticClass: "safeCode"
  }, [_vm._v("12211221")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tipBox"
  }, [_c('div'), _vm._v("\r\n                    项目编号、安全码信息\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "showFunc",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.showFunc(1)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "如何查找到电脑特征码？",
      "name": "2"
    }
  }, [_c('div', [_vm._v("电脑特征码需要按照线下管理平台软件，打开软件系统将自动弹出。您可以复制或者保存电脑特征码值。")]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": require(".././assets/cer.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tipBox",
    staticStyle: {
      "top": "-130px",
      "left": "578px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80px",
      "left": "-80px"
    }
  }), _vm._v("\r\n                电脑特征值\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "showFunc",
    staticStyle: {
      "margin-top": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.showFunc(2)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "证书类型区别是什么？",
      "name": "3"
    }
  }, [_c('div', [_vm._v("工程调试证书：属于项目施工阶段工程人员安装调试时间使用，有效期为15天。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_vm._v("正式证书：线下平台服务器正式使用激活使用")]), _vm._v(" "), _c('div', {
    staticClass: "showFunc",
    on: {
      "click": function($event) {
        return _vm.showFunc(3)
      }
    }
  }, [_vm._v("收起")])])], 1)], 1)])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assessTit"
  }, [_c('div', {
    staticClass: "commonW",
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/wangLG.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../assets/tel.png")
    }
  })]), _vm._v("  400-777-5999")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer clear-fix",
    staticStyle: {
      "width": "100%",
      "min-width": "1100px"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "1100px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/about.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业介绍")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/qiyewenhua.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("企业文化")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/zizhirongyu.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("资质荣誉")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/hezuohuoban73.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#C0C0C0"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.itlong.com.cn/pinpaiziyuan.html",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("品牌资源")])])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor1"
  }), _vm._v(" "), _c('div', {
    staticClass: "concatUs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', [_vm._v("总　　机　0755-86675999 ")]), _vm._v(" "), _c('div', [_vm._v("销售邮箱　shangwu@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("售后邮箱　fw@itlong.com.cn")]), _vm._v(" "), _c('div', [_vm._v("总部地址　深圳市南山区学苑大道1001号南山智园C1栋12楼")]), _vm._v(" "), _c('div', [_vm._v("邮　　编　518055   ")])]), _vm._v(" "), _c('div', {
    staticClass: "footerBor footerBor2"
  }), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_c('div', [_vm._v("Copyright © 1997-2020 版权所有:深圳市旺龙智能科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("粤ICP备18085992号")]), _vm._v(" "), _c('div', [_vm._v("旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b5761cd0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Question.vue
// module id = 788
// module chunks = 1